<template>
	<div>
		<page-title-bar></page-title-bar>
		<receipt-image
			:dialog.sync="openReceiptModal"
			ref="receiptModal"
		></receipt-image>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap>
				<app-card :fullBlock="true" colClasses="xs12">
					<v-card-title>
						<v-btn
							color="primary"
							:loading="refreshLoading"
							fab
							icon
							small
							outline
							@click="refreshShoppings"
						>
							<v-icon class="zmdi zmdi-refresh-sync"></v-icon>
						</v-btn>
						<v-spacer></v-spacer>
						<v-text-field
							append-icon="search"
							hide-details
							:label="$t('message.search')"
							single-line
							v-model="search"
						></v-text-field>
					</v-card-title>

					<v-data-table
						:headers="headers"
						:items="newItems"
						:search="search"
						:pagination.sync="pagination"
						no-data-text="No hay datos que mostrar"
						no-results-text="No hay resultados que mostrar"
					>
						<template slot="headerCell" slot-scope="props">
							<v-tooltip bottom>
								<span slot="activator">{{
									$t(`message.${props.header.text}`)
								}}</span>
								<span>{{ $t(`message.${props.header.text}`) }}</span>
							</v-tooltip>
						</template>
						<template slot="items" slot-scope="props">
							<td class="text-center">{{ props.item.code }}</td>
							<td v-if="user.role_id === userRoles.DELIVERY">
								{{ props.item.store.name }}
							</td>
							<td class="text-center">
								<purchase-status-button
									:purchaseStatusId.sync="props.item.purchase_status_id"
									:route="`shopping-details/${props.item.id}`"
								></purchase-status-button>
							</td>
							<td>{{ props.item.client.fullName }}</td>
							<td>{{ props.item.client.email || "cliente telegram" }}</td>
							<td>{{ props.item.updated_at }}</td>
							<td>{{ getDetail(props.item)}}</td>
							<!-- <td>{{ props.item.rating }}</td> -->
							<td class="text-left">
								<v-tooltip top>
									<v-btn
										color="primary"
										fab
										icon
										small
										slot="activator"
										outline
										:to="`shopping-details/${props.item.id}`"
									>
										<v-icon light>search</v-icon>
									</v-btn>
									<span>{{ $t("message.details") }}</span>
								</v-tooltip>
								<v-tooltip top>
									<v-btn
										@click="onReceipt(props.item)"
										color="amber"
										fab
										icon
										small
										outline
										slot="activator"
									>
										<v-icon light>zmdi-collection-image-o</v-icon>
									</v-btn>
									<span>{{ $t("message.receiptImage") }}</span>
								</v-tooltip>
								<v-tooltip top v-if="user.role_id == userRoles.CLIENT">
									<v-btn
										@click="onSend(props.item)"
										color="light-green accent-4"
										fab
										icon
										slot="activator"
										small
										outline
									>
										<v-icon>zmdi-mail-send</v-icon>
									</v-btn>
									<span>{{ $t("message.sendMessage") }}</span>
								</v-tooltip>
							</td>
						</template>
					</v-data-table>
				</app-card>
			</v-layout>
		</v-container>
		<user-message
			:broadcast="broadcast"
			:dialog.sync="showSendMessage"
			ref="userMessage"
		></user-message>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { userRoles, purchaseStatus } from "../../constants/constants";
import { GET_SHOPPINGS } from "../../store/modules/shoppings/actions.type";
import { GET_TELEGRAM_USERS } from "../../store/modules/storeModule/actions.type";
import { generateFullClientNameProp } from "../../helpers/helpers";
import UserMessage from "../telegramUsers/UserMessage";
import ReceiptImage from "./ReceiptImage";
import PurchaseStatusButton from "../custom/PurchaseStatusButton";

export default {
	name: "shoppingList",
	components: {
		ReceiptImage,
		UserMessage,
		PurchaseStatusButton,
	},
	data() {
		return {
			search: "",
			openReceiptModal: false,
			showSendMessage: false,
			refreshLoading: false,
			broadcast: false,
			newItems: [],
			headers: [
				{ text: "code", align: "center", sortable: true, value: "code" },
				{
					text: "status",
					align: "center",
					sortable: true,
					value: "purchase_status_id",
				},
				{ text: "client", sortable: true, value: "client.fullName" },
				{ text: "email", sortable: true, value: "client.email" },
				{ text: "lastUpdate", sortable: true, value: "updated_at" },
				{
					text: "details",
					sortable: false,
					value: "",
				},
				// { text: "rating", sortable: true, value: "rating" },
				{ text: "actions", sortable: false, value: "" },
			],
			purchaseStatus: purchaseStatus,
			userRoles: userRoles,
			pagination: {
				descending: true,
				sortBy: "updated_at",
				rowsPerPage: 10,
			},
		};
	},
	computed: {
		...mapGetters({
			shoppings: "shoppings",
			telegramUsers: "telegramUsers",
			user: "getUser",
			store: "store",
		}),
		userRole() {
			const { role_id } = JSON.parse(localStorage.getItem("userData"));
			return role_id;
		},
	},
	created() {
		this.getShoppings();
		if (this.userRole !== userRoles.CASHIER) this.getTelegramUsers();
	},
	methods: {
		async refreshShoppings() {
			this.refreshLoading = true;
			await this.$store.dispatch(GET_SHOPPINGS).then(() => {
				this.refreshLoading = false;
			});
		},
		getShoppings() {
			this.$store.dispatch(GET_SHOPPINGS).then(() => {
				generateFullClientNameProp(this.shoppings);
				this.newItems = this.shoppings;
			});
		},
		getTelegramUsers() {
			this.$store.dispatch(GET_TELEGRAM_USERS);
		},
		onReceipt(receipt) {
			this.$refs.receiptModal.setValue(receipt.full_url_image);
			this.openReceiptModal = true;
		},
		onSend(client) {
			let user = {
				id: client.client_id,
			};
			this.$refs.userMessage.setValue(user);
			(this.showSendMessage = true), (this.broadcast = false);
		},
		checkReceiptDetails(receipt) {
			this.$router.push({ name: "shoppingDetails", param: { id: receipt.id } });
		},
		getDetail(item) {
			return item.note;
		}
	},
};
</script>

<style></style>
